module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[35]522.4df63aa.woff2";